import React, {useEffect, useState} from 'react';
import {Route, Routes} from "react-router-dom";
import HomePage from "./pages/HomePage";
import SharePage from "./pages/SharePage/SharePage";
import {apiV2} from "./modules/apiV2";
import {Terms, Policy} from "./pages/TermsPage";

function App() {

  useEffect(() => {
    init()
  }, []);

  const init = async () => {
    try {
      return false
      // return res.data;
    } catch (e) {
      throw e;
    }
  }

  return (
    <main>
      <Routes>
        <Route path="/" element={<HomePage/>}/>
        <Route path='/terms' element={<Terms/>}/>
        <Route path='/policy' element={<Policy/>}/>
        <Route path="/share" element={<SharePage/>}/>
      </Routes>
    </main>
  );
}

export default App;
